import React from 'react';
import { useTranslation } from 'react-i18next';
import closeButtonPic from '../../../assets/designSystem/icons/close.svg';
import Button from '../../../components/Inputs/Button';
import './popup.css';

export default function diarrhoea({ babyOrChild, callback }) {
  const { t } = useTranslation();
  return (
    <>
      <div className="modal__backdrop" />
      <div className="modal__popup">
        <div className="popup__container">
          <img
            src={closeButtonPic}
            alt="close button"
            className="popup__closeBtn"
            role="presentation"
            width="24"
            onClick={callback}
          />
          <div className="popup__content">
            <h4 className="popup__title">{t('popUps.diarrhoea.title')}</h4>
            <div>
              <p>{t(`popUps.diarrhoea.${babyOrChild}.p1`)}</p>
              <br />
              <ul className="popup__ul">
                <li>{t('popUps.diarrhoea.li1')}</li>
                <li>{t(`popUps.diarrhoea.${babyOrChild}.li2`)}</li>
                <li>{t(`popUps.diarrhoea.${babyOrChild}.li3`)}</li>
                <li>{t(`popUps.diarrhoea.${babyOrChild}.li4`)}</li>
                <li>{t('popUps.diarrhoea.li5')}</li>
                <li>{t('popUps.diarrhoea.li6')}</li>
                <li>{t('popUps.diarrhoea.li7')}</li>
                <li>{t(`popUps.diarrhoea.${babyOrChild}.li8`)}</li>
              </ul>
            </div>
          </div>
          <div className="popup__button">
            <Button width="fullWidth" hierarchy="primary" onClick={callback}>
              {t('popUps.button')}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
